import React from "react";
import { Grid2, Theme, Typography, useMediaQuery } from "@mui/material";

const GridItem = ({ label, value }: { label: string; value?: string }) => {
  const isLessSm = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  return (
    <Grid2
      display="flex"
      flexDirection="column"
      size={{
        xs: 4,
        sm: 3,
      }}
    >
      <Typography
        variant={isLessSm ? "caption" : "body2"}
        color="textSecondary"
      >
        {label}
      </Typography>
      <Typography variant={isLessSm ? "body2" : "body1"}>
        {value || "-"}
      </Typography>
    </Grid2>
  );
};

type Props = {
  items: {
    label: string;
    value: string;
  }[];
};

export const DataGrid = ({ items }: Props) => {
  return (
    <Grid2 container spacing={3}>
      {items.map((item) => (
        <GridItem label={item.label} value={item.value} />
      ))}
    </Grid2>
  );
};
